import React from 'react';
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AppProvider, useApp } from './context/AppContext';
import './styles/globals.css';

import Login         from './pages/Login';
import Dashboard     from './pages/Dashboard';
import PendingQueue  from './pages/PendingQueue';
import Clients       from './pages/Clients';
import StockLedger   from './pages/StockLedger';
import WorkCards     from './pages/WorkCards';
import Billing       from './pages/Billing';
import Invoices      from './pages/Invoices';

function AppContent() {
  const { state } = useApp();

  if (!state.auth.isAuthenticated) {
    return <Login />;
  }

  return (
    <Routes>
      <Route path="/"          element={<Navigate to="/dashboard" replace />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/pending"   element={<PendingQueue />} />
      <Route path="/clients"   element={<Clients />} />
      <Route path="/ledger"    element={<StockLedger />} />
      <Route path="/workcards" element={<WorkCards />} />
      <Route path="/billing"   element={<Billing />} />
      <Route path="/invoices"  element={<Invoices />} />
      <Route path="*"          element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <HashRouter>
      <AppProvider>
        <AppContent />
      </AppProvider>
    </HashRouter>
  );
}
